/**
 * applyCaseConvert
 * apple case covert to axios client, the aim is using camel case in client side;
 * and using snake case when call Omnitech API
 */

import _ from 'lodash'
import snakeCaseKeys from '../../vendor/snakecase-keys'
import camelcaseKeys from '../../vendor/camelcase-keys'

export default function applyCaseConvert(instance) {
  // Add a response interceptor
  instance.interceptors.response.use(
    // convert camel case keys for success response moved to omnitech-api to accept custom options for camelcase
    _.identity,
    (error) => {
      const errorData = _.get(error, 'response.data', {})
      error = _.set(error, 'response.data', camelcaseKeys(errorData, { deep: true }))
      return Promise.reject(error)
    }
  )

  // Add a request interceptor
  instance.interceptors.request.use(
    (config) => {
      config = {
        ...config,
        data: snakeCaseKeys(config.data || {}, {exclude: [/__[A-Za-z_]+/, /[|]/, /h5_[a-z_]+/]}), // skip keys like `__try_decline_order`
        params: snakeCaseKeys(config.params || {}, {exclude: [/__[A-Za-z_]+/, /[|]/]}),
      }
      return config
    },
    (error) => {
      return Promise.reject(error)
    }
  )

  return instance
}
